





































import { MediaObject } from "@/interfaces/mediaobject";
import Vue, { PropType } from "vue";
export default Vue.extend({
  props: {
    value: File as PropType<File | null>,
    uploaded: Object as PropType<MediaObject>,
    required: Boolean,
    canDelete: Boolean,
    noExtraButton: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      reloading: false
    };
  },
  computed: {
    objectURL(): string {
      if (!this.value) {
        // return 1px
        return "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQI12NgYAAAAAMAASDVlMcAAAAASUVORK5CYII=";
      }
      return URL.createObjectURL(this.value);
    }
  },
  methods: {
    input(): void {
      this.reloading = true;
      this.$nextTick(() => {
        this.reloading = false;
      });
    },
    deleteFile(): void {
      confirm("ファイルを削除します。") && this.$emit("delete");
    }
  }
});
